<template>
  <div>
    <div v-if="panelError" class="min-h-screen bg-slate-900 text-white flex items-center justify-center p-8">
      <div class="max-w-md text-center space-y-4">
        <h1 class="text-2xl font-bold">Admin panel failed to load</h1>
        <p class="text-slate-300">{{ panelError }}</p>
        <button type="button" class="px-4 py-2 bg-emerald-600 rounded-lg" @click="reload">Reload</button>
      </div>
    </div>
    <AdminPanel v-else />
  </div>
</template>

<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'
import AdminPanel from '@/components/admin/AdminPanel.vue'

const panelError = ref('')

onErrorCaptured((err) => {
  panelError.value = err instanceof Error ? err.message : 'Unexpected admin panel error'
  return false
})

const reload = () => {
  window.location.reload()
}
</script>
